import axios, { axiosPrivate } from "../api/axios";
import {
  LOGIN_API,
  LOGOUT_API,
  REFRESH_API,
  REQUEST_PASSWORD_RESET_API,
  RESET_PASSWORD_API,
  VERIFY_EMAIL_API,
} from "./endpoints";
import API_URLS from "../constants/apiConstants";

export const loginAPI = (email, password) => {
  return axiosPrivate.post(
    LOGIN_API,
    JSON.stringify({ email, password })
  );
};

export const refreshTokenAPI = () => {
  return axiosPrivate.post(
    REFRESH_API,
    {},
  );
};

export const logoutAPI = () => {
  return axiosPrivate.post(LOGOUT_API);
};

export const registerAPI = (data) => {
  const userData = {
    first_name: data.firstName,
    last_name: data.lastName,
    email: data.email,
    password: data.password,
    password2: data.password2,
    
    name: data.schoolName,
    phone: data.phone,
    capacity: data.capacity,
    countries: data.countries,
    program_type: data.programType,
  }
  const apiUrl = API_URLS.createNurseryWithOwner;

  return axiosPrivate.post(apiUrl, JSON.stringify(userData));
};

export const verifyEmailAPI = (uid, token) => {
  return axios.get(`${VERIFY_EMAIL_API}/${uid}/${token}`);
};

export const requestPasswordResetAPI = (email) => {
  return axios.post(REQUEST_PASSWORD_RESET_API, { email });
};

export const resetPasswordAPI = (uid, token, password) => {
  return axios.post(RESET_PASSWORD_API, {
    uid: uid,
    token: token,
    password: password,
  });
};
